<template>
    <div ref="content" class="app-content" :style="contentStyle">
        <book-page ref="bookPage" />
        <tool-bar ref="toolBar" />
        <div class="afile" v-for="(afile, index) in afiles" :key="afile.id" :id="'afile' + index">
            <a-file
                :ref="`afile_${afile.fileName}_${afile.frame}`"
                v-if="afile.type == 'afile'"
                @closeAFile="removeAFile"
                :AFileConfig="afile"
                :style="{ 'z-index': 30 - index }"
            />
            <a-file-movie
                :ref="`afile_${afile.fileName}_${afile.frame}`"
                v-if="afile.type == 'afileMovie'"
                :AFileConfig="afile"
                @closeAFile="removeAFile"
                :style="{ 'z-index': 30 - index }"
            />
            <a-file-change-image
                :ref="`afile_${afile.fileName}_${afile.frame}`"
                v-if="afile.type == 'afileImage'"
                :AFileConfig="afile"
                :style="{ 'z-index': 30 - index }"
            />
        </div>
        <sound_manager-vue ref="soundManager" :audio-config="audioConfig"></sound_manager-vue>
        <PageTags ref="pageTags" />
        <ChangePageButtons />
        <SwitchPenArea />

        <Directory class="window-scale" ref="directory" />
        <QuickDirectory class="window-scale" ref="quickDirectory" />
        <WhiteBoard ref="whiteBoard" />
        <GraphicBoard ref="graphicBoard" />
        <PaintBoard class="window-scale" ref="paintBoard" />
        <StampBoard ref="stampBoard" />
        <PolygonCreater class="window-scale" ref="polygonCreater" />
        <InsertWebLink class="window-scale" ref="insertWebLink" />
        <InsertPicture class="window-scale" ref="insertPicture" />
        <Sticky class="window-scale" ref="sticky" />
        <TextBox class="window-scale" ref="textBox" />
        <Setting class="window-scale" ref="setting" />
        <SummaryGraph class="window-scale" ref="summaryGraph" />

        <confirm-dialog ref="confirmDialog" />
        <alert-dialog ref="alertDialog" />
        <prompt-dialog ref="promptDialog" />
        <save-dialog ref="saveDialog" />
        <message-dialog ref="messageDialog" />
        <exit-dialog ref="exitDialog" />

        <CursorSetting ref="cursorSetting"></CursorSetting>
        <MenuRight ref="menuRight"></MenuRight>
        <MenuMiddle ref="menuMiddle"></MenuMiddle>

        <UserRecord ref="userRecord"></UserRecord>
        <Countdown ref="countdown"></Countdown>
        <Stopwatch ref="stopwatch"></Stopwatch>

        <LessonExamTip ref="lessonExamTip"></LessonExamTip>
        <LessonExamSelector ref="lessonExamSelector"></LessonExamSelector>
        <LessonExam ref="lessonExam"></LessonExam>
        <LessonExamViewer ref="lessonExamViewer"></LessonExamViewer>

        <FetchRecord ref="fetchRecord"></FetchRecord>
        <LoginType ref="loginType"></LoginType>
        <LoginKnsh ref="loginKnsh"></LoginKnsh>
        <MergeConfirm ref="mergeConfirm"></MergeConfirm>

        <IframeContainer ref="iframeContainer"></IframeContainer>
    </div>
</template>

<script>
import AFileChangeImage from "./components/AFile/AFileChangeImage.vue";
import BookPage from "./components/BookPage.vue";
import ToolBar from "./components/ToolBar.vue";
import AFile from "./components/AFile/AFile.vue";
import AFileMovie from "./components/AFile/AFileMovie.vue";

import AFileControl from "./js/afile_control";
import EventBus from "./js/event_bus";
import ToolBox from "./components/ToolBox.vue";

import CursorSetting from "./components/cursor/CursorSetting.vue";
import MenuMiddle from "./components/cursor/MenuMiddle.vue";
import MenuRight from "./components/cursor/MenuRight.vue";

import sound_managerVue from "./components/sound_manager.vue";
import Directory from "./components/Directory.vue";
import QuickDirectory from "./components/QuickDirectory.vue";
import { BOOK_TYPE } from "./js/book_define/book_type";
import AppRenderer from "./js/app_renderer";
import WhiteBoard from "./components/UI/WhiteBoard.vue";
import PaintBoard from "./components/UI/PaintBoard.vue";
import StampBoard from "./components/UI/StampBoard.vue";
import PolygonCreater from "./components/UI/PolygonCreater.vue";
import InsertWebLink from "./components/InsertWebLink.vue";
import InsertPicture from "./components/InsertPicture.vue";
import Sticky from "./components/Sticky.vue";
import TextBox from "./components/TextBox.vue";
import PageTags from "./components/PageTags.vue";
import ChangePageButtons from "./components/ChangePageButtons.vue";
import SwitchPenArea from "./components/SwitchPenArea.vue";
import Setting from "./components/setting/Setting.vue";
import { settingStore } from "./js/store/settingStore";
import PainterProxy from "./js/painter/proxy";
import ConfirmDialog from "./components/dialogs/ConfirmDialog.vue";
import AlertDialog from "./components/dialogs/AlertDialog.vue";
import PromptDialog from "./components/dialogs/PromptDialog.vue";
import SaveDialog from "./components/dialogs/SaveDialog.vue";
import ExitDialog from "./components/dialogs/ExitDialog.vue";
import UserRecord from "./components/dialogs/userRecord/UserRecord.vue";
import SummaryGraph from "./components/SummaryGraph.vue";

import LessonExam from "./components/lessonExam/LessonExam.vue";
import LessonExamSelector from "./components/lessonExam/LessonExamSelector.vue";
import LessonExamTip from "./components/lessonExam/LessonExamTip.vue";
import LessonExamViewer from "./components/lessonExam/LessonExamViewer.vue";

import Cursor from "@/js/cursor/cursor.js";

import Countdown from "./components/iframeTool/Countdown.vue";
import Stopwatch from "./components/iframeTool/Stopwatch.vue";
import FetchRecord from "./components/dialogs/userRecord/FetchRecord.vue";

import LoginType from "./components/dialogs/login/LoginType.vue";
import LoginKnsh from "./components/dialogs/login/LoginKnsh.vue";
import MergeConfirm from "./components/dialogs/userRecord/MergeConfirm.vue";
import { store, originBookSize } from "./store";
import { focusStore } from "./js/store/nowFocusStore";

import IframeContainer from "./components/Iframe.vue";
import GraphicBoard from "./components/UI/GraphicBoard.vue";
import MessageDialog from "./components/dialogs/MessageDialog.vue";
import { VIEW_TYPE } from "./js/view_type";
import BackgroundWeb from "./background_web";
import BackgroundApp from "./background_app";

export default {
    name: "App",
    components: {
        ToolBox,
        AFileChangeImage,
        BookPage,
        ToolBar,
        AFile,
        AFileMovie,
        sound_managerVue,
        Directory,
        QuickDirectory,
        WhiteBoard,
        PaintBoard,
        StampBoard,
        PolygonCreater,
        InsertWebLink,
        InsertPicture,
        Sticky,
        TextBox,
        PageTags,
        ChangePageButtons,
        SwitchPenArea,
        Setting,
        ConfirmDialog,
        AlertDialog,
        PromptDialog,
        SaveDialog,
        CursorSetting,
        MenuRight,
        MenuMiddle,
        UserRecord,
        SummaryGraph,
        Countdown,
        Stopwatch,
        LessonExam,
        LessonExamSelector,
        LessonExamTip,
        LessonExamViewer,
        FetchRecord,
        LoginType,
        LoginKnsh,
        MergeConfirm,
        IframeContainer,
        GraphicBoard,
        MessageDialog,
        ExitDialog,
    },
    mounted: function () {
        const self = this;

        window.compositionMap = new Map();
        window.resourceMap = new Map();
        window.aFileControl = AFileControl.getInstance();
        window.aFileControl.afiles = this.afiles;
        window.app = this;
        EventBus.getInstance().setApp(this);

        setTimeout(() => {
            this.updatePageSize();
            originBookSize.set(window.pageWidth, window.pageHeight);
        }, 100);

        Cursor.getInstance().setMenuRight(this.$refs.menuRight);
        Cursor.getInstance().setMenuMiddle(this.$refs.menuMiddle);

        window.addEventListener("pointerdown", this.cursorClick, true);
        window.addEventListener("pointerdown", this.checkFocusWindow, true);
        window.onresize = () => {
            store.contentScaleX = window.outerWidth / this.maxWidth;
            store.contentScaleY = window.innerHeight / this.maxHeight;
            this.contentScale = Math.min(store.contentScaleX, store.contentScaleY);
            store.contentScale = this.contentScale;

            store.windowDevicePixelRatio = window.devicePixelRatio;

            document.documentElement.style.setProperty("--innerHeight", `${window.innerHeight}px`);
        };

        window.dispatchEvent(new Event("resize"));

        window.addEventListener("pointerup", (e) => {
            if (typeof self.handleWindowPointerup == "function") {
                self.handleWindowPointerup(e);
                self.handleWindowPointerup = null;
            }
        });

        store.appContent = this.$refs.content;
    },
    methods: {
        checkFocusWindow() {
            if (!focusStore.isFocusPaintBoard) {
                this.$refs.paintBoard.closeBoard();
            }

            if (!focusStore.isFocusToolBar && !focusStore.isFocusToolBox) {
                this.$refs.toolBar.$refs.toolBox.closeBox();
            }

            if (!focusStore.isFocusToolBar && !focusStore.isFocusQuickDirectory) {
                this.$refs.quickDirectory.closeDirectory();
            }
        },
        initPageScale: function () {
            this.$refs.bookPage.initSvg();
        },
        addAfile: function () {
            this.afiles.push({
                type: "afileImage",
                id: new Date().getTime(),
            });
        },
        cursorClick: function (e) {
            Cursor.getInstance().cursorClick(e);
        },
        updatePageSize() {
            if (store.onlyRead) {
                this.maxWidth = 1583;
                store.baseSize.width = 1583;
            } else {
                this.maxWidth = settingStore.toolbarPosition == 0 ? store.horizonContainerWidth : store.verticalContainerWidth;
                store.baseSize.width = settingStore.toolbarPosition == 0 ? store.horizonContainerWidth : store.verticalContainerWidth;
            }

            window.pageWidth = store.baseSize.width - this.$refs.toolBar.getToolBarWidth();
            window.pageHeight = store.baseSize.height - this.$refs.toolBar.getToolBarHeight();

            store.pageWidth = window.pageWidth;
            store.pageHeight = window.pageHeight;

            const self = this;
            setTimeout(() => {
                self.$refs.bookPage.backPosition();
            });
        },
        updateWindowContainerScale() {
            let minScale = Math.min(window.pageWidth / 1920, window.pageHeight / 936);
            document.documentElement.style.setProperty("--window-scale", minScale);
            store.setWindowScale(minScale);
        },
        updateAFilesSize() {
            const afiles = AFileControl.getInstance().afiles;
            const self = this;
            if (afiles.length > 0) {
                afiles.forEach((item) => {
                    self.$refs[`afile_${item.fileName}_${item.frame}`][0].$refs.aFileWindow.$refs.aFileTool.resize();
                });
            }
        },
        setWindowPointerup(func) {
            this.handleWindowPointerup = func;
        },
    },
    created: function () {
        switch (store.nowView) {
            case VIEW_TYPE.WEB:
                window.ipcRenderer = new BackgroundWeb();
                break;
            case VIEW_TYPE.ANDROID:
            case VIEW_TYPE.IOS:
                window.ipcRenderer = new BackgroundApp();
                break;
            default:
                break;
        }
        AppRenderer.Instance.getPath("exe");
        //禁止預設右鍵選單
        document.oncontextmenu = function (e) {
            return false;
        };
        this.maxWidth = 1393;
        this.maxHeight = 1017;
    },
    data: function () {
        return {
            afiles: [],
            toolbarHeight: 100,
            directoryContent: {},
            nowBook: BOOK_TYPE.BOOK,
            nowPage: 0,
            settingStore,
            audioConfig: {},
            focusStore,
            maxWidth: 1920,
            maxHeight: 1017,
            contentScale: 1,
            handleWindowPointerup: () => {},
            content: null,
            store,
        };
    },
    watch: {
        "settingStore.isPenClick": {
            handler: function () {
                PainterProxy.getInstance().setPenClick(!Boolean(settingStore.isPenClick));
            },
        },
        "focusStore.bookPageItemControl": {
            handler: function () {
                if (focusStore.bookPageItemControl == null) {
                    store.clearDisabledTools();
                } else {
                    switch (focusStore.getNowPageItemControl().type) {
                        case "mainPage":
                            if (this.$refs.stampBoard.isShow) {
                                return;
                            }
                            store.clearDisabledTools();
                            break;
                        case "whiteBoard":
                            store.setWhiteboardDisabledTools();
                            break;
                        case "afile":
                        case "afileImage":
                            store.setAFileDisabledTools();
                            break;
                        case "afileMovie":
                            store.setAFileMovieDisabledTools();
                            break;
                        case "graphicBoard":
                            store.setGraphicDisabledTools();
                            break;
                    }
                }
            },
        },
    },
    computed: {
        contentStyle() {
            store.contentScaleX = window.outerWidth / this.maxWidth;
            store.contentScaleY = window.innerHeight / this.maxHeight;
            store.contentScale = Math.min(store.contentScaleX, store.contentScaleY);
            if (settingStore.isFixed == 0) {
                return {
                    width: this.maxWidth + "px",
                    height: this.maxHeight + "px",
                    transform: "scale(" + store.contentScale + ")",
                    left: store.onlyRead ? "calc(50% - 791.5px)" : settingStore.toolbarPosition == 0 ? "calc(50% - 728.5px)" : "calc(50% - 823.5px)",
                };
            } else {
                return {
                    width: this.maxWidth + "px",
                    height: this.maxHeight + "px",
                    transform: "scale(" + store.contentScaleX + "," + store.contentScaleY + ")",
                    left: settingStore.toolbarPosition == 0 ? "calc(50% - 728.5px)" : "calc(50% - 823.5px)",
                };
            }
        },
    },
};
</script>
<style src="./css/fonts.css"></style>
<style>
:root {
    --window-scale: 1;

    --innerHeight: 100vh;

    --z-index-svg-clip-path: 10;
    --z-index-page-container: 20;
    --z-index-switch-pen-area: 21;
    --z-index-page-tag: 22;
    --z-index-change-page-buttons: 23;
    --z-index-only-read-buttons: 24;
    --z-index-afile: 30;
    --z-index-sound-manager: 31;
    --z-index-tools: 39;
    --z-index-directory: 40;
    --z-index-insert-web-link: 41;
    --z-index-sticky: 42;
    --z-index-polygon-creater: 43;
    --z-index-toolbox: 45;
    --z-index-setting: 46;
    --z-index-cursor-setting: 47;
    --z-index-iframe-tool: 50;
    --z-index-iframe: 51;
    --z-index-white-board: 60;
    --z-index-white-board-editor: 60;
    --z-index-direction-bar: 61;
    --z-index-text-box: 61;
    --z-index-painter-board: 70;
    --z-index-user-record: 71;
    --z-index-stamp-board: 72;
    --z-index-cursor-middle-menu: 80;
    --z-index-cursor-right-menu: 81;
    --z-index-lesson-exam: 82;
    --z-index-save-dialog: 83;
    --z-index-insert-picture: 84;
    --z-index-confrim-dialog: 101;
    --z-index-prompt-dialog: 102;
    --z-index-alert-dialog: 103;
    --z-index-loading-mask: 9999;
}

.window-scale {
    transform: scale(var(--window-scale));
}

body {
    position: fixed;
    margin: 0px;
    background: black;
    overflow: hidden;
    touch-action: none;
}

div {
    user-select: none;
}

#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    overflow: hidden;
    width: 100vw;
    height: calc(var(--innerHeight, 1vh));
    touch-action: none;
}

.app-content {
    top: 0;
    bottom: 0;
    transform-origin: center;
    margin: auto;
    position: absolute;
    overflow: hidden;
}

.afile {
    position: absolute;
    transform-origin: left top;
    /* z-index: var(--z-index-afile); */
}
</style>
